import { Label } from "reactstrap";
import StatusBadge from "../../Components/UI/statusBadge";
import TableActions from "../../Components/UI/table/TableActions";
import { formatPrice } from "../../utils/formatPrice";
import StarIcon from "../../Components/Common/svg/rewardsstats/star";
import UsersIcon from "../../Components/Common/svg/usersIcon";
import CleanerIcon from "../../Components/Common/svg/rewardsstats/cleander";
import CoinsIcon from "../../Components/Common/svg/rewardsstats/coins";
import ShoppingIcon from "../../Components/Common/svg/shoppingicon";

export const rewardsStatsConfig = (statics) => [
  {
    title: "إجمالي النقاط  ",
    count: statics?.total_points,
    color: "#FFCC03",
    icon: <StarIcon/>,
    bgIcon: "#E6F3EF",
  },
  {
    title: "عدد العملاء ",
    count: statics?.customers_count,
    color: "#003726",
    icon:<UsersIcon/>, 
    bgIcon: "#8AC6B4",
  },
  {
    title: "آخر سحب ",
    count:statics?.last_points_withdrawal && statics?.last_points_withdrawal?.date,
    color: "#616161",
    icon: <CleanerIcon/>,
    bgIcon: "#F7F7F7",
  },
];


export const orderAmountStatsConfig = (statics) => [
  {
    title: "إجمالي قيمة الطلبات",
    count:  formatPrice( statics.currency_factor ,statics?.total_order_value) ,
    color: "#FFCC03",
    icon: <StarIcon/>,
    bgIcon: "#E6F3EF",
  },
  {
    title: "عدد العملاء",
    count: statics?.customers_count,
    color: "#003726",
    icon: <UsersIcon/>,  
    bgIcon: "#8AC6B4",
  },
  {
    title: "آخر سحب ",
    count:statics?.last_points_withdrawal && statics?.last_points_withdrawal?.date,
    color: "#616161",
    icon: <CleanerIcon/>,
    bgIcon: "#F7F7F7",
  },
];

export const exchangeStatsConfig = (statics) => [
  {
    title: "مكافآت النظام",
    count: statics?.system_rewards,
    color: "#FFCC03",
    icon: <ShoppingIcon/>,
    bgIcon: "#F0FDF9",
  },
  {
    title: " عمليات الاسترداد",
    count: statics?.redemption_operations,
    color: "#003726",
    icon: <UsersIcon/>,
    bgIcon: "#8AC6B4;",
  },
  {
    title: "نقاط مصروفة",
    count: statics?.points_spent,
    color: "#FC0",
    icon: <CoinsIcon/>,
    bgIcon: "#FFF7BA",
  },
];

export const tabs = [
  { id: 1, key: "points", label: "إجمالي النقاط" ,permission:"view_reward" },

  { id: 2, key: "orders_amout", label: "سحب قيمة الطلبات" ,permission:"view_reward" },
  { id: 3, key: "exchange", label: "تبديل النقاط ",permission:"view_reward"  },
];

export const topPointsUsersColumns = [
  {
    label: "الترتيب",
    render: (row) => (
      <div className="order_count">
        {row.order_count}
      </div>
    ),
  },
  { label: "معرف العميل", accessor: "id" },
  { label: "اسم العميل", accessor: "name" },
  { label: " رقم الجوال", accessor: "phone" },
  { label: "النقاط", accessor: "loyalty_points" },
  {
    label: "الحالة",
    render: (row) => <StatusBadge status={row?.status} />,
  },

  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
      viewPermission={"view_reward"}
        show={`${process.env.PUBLIC_URL}/`}
        edit={`${process.env.PUBLIC_URL}/curior/edit/${row.id}`}
        id={row.id}
        mutationKey={["deleterewards"]}
      />
    ),
  },
];

export const exchangeColumns = [
  {
    label: "العميل",
    render: (row) => (
      <div className="order_count">
        {row.order_count}
      </div>
    ),
  },
  { label: " المكافأة", accessor: "id" },
  { label: "النوع ", accessor: "name" },
  { label: "عدد النقاط", accessor: "phone" },
  { label: "رقم العملية", accessor: "loyalty_points" },

  { label: "التاريخ", accessor: "loyalty_points" },

];

export const systemRewardsColumns = [
  {
    label: "المكافأه",
    render: (row) => (
      <div >
        {row.title}
      </div>
    ),
  },
  { label: "الوصف", accessor: "description" },
  { label: "القيمة", render:(row)=> <div>{row.type ==="wallet"? row.value_amount:row.coupon.code} </div> },
  { label: "النوع", accessor: "type" },
  { label: "عدد النقاط", render:(row)=> <div>{row.points_cost} </div> },
   { label: "مرات الإستخدام", accessor: "usage_count" },
      { label: " المرات المستخدمة", accessor: "count_of_use" },
  {
    label: "الحالة",
    render: (row) => <StatusBadge status={row?.is_active?"active":"inActive"} />,
  },
  { label: "تاريخ الانتهاء", accessor: "end_date" },
  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        show={`${process.env.PUBLIC_URL}/curior/${row.id}`}
        editPermission="update_reward"
        deletePermission="delete_reward"
        id={row.id}
        mutationKey={["deleterewards"]}
      />
    ),
  },
];
